
import { get } from "lodash";
import { run } from 'formula';
import { InterpolateService } from '@ispm/shared/services/interpolate.service';
import { FormulaService } from '@ispm/shared/services/formula.service';

export class FormulaAggregatorService {

    private interpolator: InterpolateService;
    constructor() { }

    executeFormula(data: any, formulaAggr: any) {
        let calculatedValue = null;
        let pathologyfinding = data.pathologyFindings;

        if (pathologyfinding !== undefined && pathologyfinding != null) {
            for (let i = 0; i < pathologyfinding.length; i++) {
                formulaAggr.forEach(aggregator => {
                    if (pathologyfinding[i].hasOwnProperty(aggregator['affectedField'])) {
                        let formula = aggregator['formula'];
                        let valuetoset = aggregator['valueToSet'];
                        let isInterpolate = aggregator['interpolate'];

                        if (isInterpolate) {
                            calculatedValue = FormulaService.evaluateFormula(formula, pathologyfinding[i])
                        }

                        if (calculatedValue === true) {
                            pathologyfinding[i][aggregator['affectedField']] = Number(pathologyfinding[i][aggregator['affectedField']]) + Number(valuetoset);
                        }
                    }
                })
            }
        }
    }

    executeFormula_temptest(data: any, formula: string, valuetoset: any, isInterpolate: boolean): any {
        let calculatedValue = null;
        let totalCount = 0;
        let pathologyfinding = data.pathologyFindings;

        if (pathologyfinding !== undefined && pathologyfinding != null) {
            for (let i = 0; i < pathologyfinding.length; i++) {
                if (isInterpolate) {
                    calculatedValue = FormulaService.evaluateFormula(formula, pathologyfinding[i])
                }

                if (calculatedValue === true) {
                    totalCount = totalCount + Number(valuetoset);
                }
            }
        }
        return totalCount;
    }

    executeFormula_1(data: Array<any>, formula: string, valuetoset: any, isInterpolate: boolean): any {
        let calculatedValue = null;

        if (isInterpolate) {
            calculatedValue = run(this.interpolator.interpolate(formula, data, true), {});
        }
        else {
            calculatedValue = run(formula, data);
        }

        if (calculatedValue instanceof Error) {
            calculatedValue = null;
        }

        if (calculatedValue >= 0) {
            return valuetoset;
        }
        else {
            return 0;
        }

        //try {
        //   calculatedValue = run(this.interpolator.interpolate(formula, data, true), { });
        //   if (calculatedValue instanceof Error) {
        //     calculatedValue = null;
        //   }
        //   calculatedValue = this.getTransformedValue(calculatedValue);
        // } catch (exception) {
        //   if (this.outputTransform && (this.outputTransform[DEFAULT_OUTPUT_KEY] || this.outputTransform[DEFAULT_OUTPUT_KEY] === 0 )) {
        //     calculatedValue = this.outputTransform[DEFAULT_OUTPUT_KEY];
        //   }
        //}
        //return calculatedValue;
    }


}
